import React, { useEffect, useState } from "react";
import closeIcon from "../../assets/close_icon_black.svg";
import { useDispatch } from "react-redux";
import { closeDeleteConfirmModal } from "../../redux/slices/deleteConfirmModal";
import { useDeleteUser } from "./api";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";

export default function DeleteConfirmationModal() {
  const dispatch = useDispatch();
  const [serverError, setServerError] = useState("");
  const deleteUserMutation = useDeleteUser();
  const navigate = useNavigate();
  const onSubmit = () => {
    if (!navigator.onLine) {
      toast.error("No internet connection. Please check your network.");
      return;
    }
    setServerError("");
    deleteUserMutation.mutate(undefined, {
      onSuccess: () => {
        toast.success("Account deleted successfully.", {
          position: "top-center",
          autoClose: 3000,
          hideProgressBar: true,
        });
        navigate("/log-in");
      },
      onError: (error: any) => {
        setServerError(
          error.response?.data?.message ||
            "An error occurred while deleting the account."
        );
      },
    });
  };

  useEffect(() => {
    if (serverError) {
      toast.error(serverError);
    }
  }, [serverError]);

  return (
    <div className='fixed top-0 left-0 w-full h-screen z-60 flex items-center justify-center bg-black bg-opacity-80 text-black z-50'>
      <div className='flex flex-col w-4/5 sm:w-4/5 md:w-3/4 lg:w-2/3  h-1/3 rounded-md bg-white p-4 items-center'>
        <img
          src={closeIcon}
          alt='Close'
          onClick={() => dispatch(closeDeleteConfirmModal())}
          className='w-7 h-7 cursor-pointer ml-auto'
        />
        <p className='pt-6 px-5 pb-10 text-sm lg:text-base'>
          Are you sure? This action <strong>cannot</strong> be undone. Your
          account and data will be <strong>permanently removed</strong>.
        </p>
        <div className='flex w-full space-x-10 justify-center'>
          <button
            onClick={() => dispatch(closeDeleteConfirmModal())}
            className='bg-[#E3E3E3] text-black rounded-md w-24 md:w-32 py-2 hover:bg-[#D9D9D9]'
          >
            Cancel
          </button>
          <button
            className='bg-[#EC221F] text-white rounded-md w-24 md:w-32 py-2 hover:bg-[#C41E1F]'
            onClick={onSubmit}
            disabled={deleteUserMutation.isPending}
          >
            {deleteUserMutation.isPending ? "Deleting..." : "Delete"}
          </button>
        </div>
      </div>
    </div>
  );
}
